import { render, staticRenderFns } from "./CreateStatements.vue?vue&type=template&id=87265f5a&scoped=true"
import script from "./CreateStatements.vue?vue&type=script&lang=js"
export * from "./CreateStatements.vue?vue&type=script&lang=js"
import style0 from "./CreateStatements.vue?vue&type=style&index=0&id=87265f5a&prod&scoped=true&lang=scss"
import style1 from "./CreateStatements.vue?vue&type=style&index=1&id=87265f5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87265f5a",
  null
  
)

export default component.exports